import { Component, Input } from '@angular/core';

/** Lightweight stub for unfinished default-route pages. */
@Component({
  selector: 'app-coming-soon',
  standalone: true,
  template: `
    <div class="coming-soon">
      <h1>{{ title }}</h1>
      <p>This page is coming soon in the new design.</p>
    </div>
  `,
  styles: `
    .coming-soon {
      padding: 2rem;
      max-width: 40rem;
    }
    h1 {
      margin: 0 0 0.5rem;
      font-family: 'Poppins', 'Inter', sans-serif;
      color: var(--scryber-text);
    }
    p {
      color: var(--scryber-text-muted);
      line-height: 1.5;
    }
  `,
})
export class ComingSoonComponent {
  @Input() title = 'Coming soon';
}
